export const CONTENT_WRP_ID = 'contentWrp';
